export default '/build/88416763.svg'